import axios from "axios";
import { TRONSCAN_API_ADDRESS } from "../../constants/config";

export class TransactionInfoService {
  public fetchTransactionInfo = async (params) => {
    try {
      const { transactionId } = params;
      //check if valid transaction id
      const queryString = `?hash=${transactionId}`;
      const { data } = await axios.get(
        `${TRONSCAN_API_ADDRESS}/transaction-info${queryString}`
      );

      const {
        block,
        hash,
        timestamp,
        ownerAddress,
        toAddress,
        confirmations,
        confirmed,
        revert,
        contractRet,
        contractData,
        cost,
        trigger_info,
        internal_transactions,
        tokenTransferInfo,
        contract_map,
      } = data;

      return {
        block,
        hash,
        timestamp,
        ownerAddress,
        toAddress,
        confirmations,
        confirmed,
        revert,
        contractRet,
        contractData,
        cost,
        trigger_info,
        internal_transactions,
        tokenTransferInfo,
        contract_map,
      };
    } catch (e) {
      console.log(e);
      if (e.message) {
        throw e;
      }
      throw new Error("Error connecting to account service");
    }
  };
}
